import { useDisclosure } from '@chakra-ui/hooks';
import { Box, BoxProps, Flex, Tooltip } from '@chakra-ui/react';
import { FC } from 'react';

import ICAward from '@/assets/icons/ic-award.svg';

interface ILectureAwardTooltip {
  award?: string;
  iconWidth?: BoxProps['w'];
  iconHeight?: BoxProps['h'];
  iconColor?: string;
}

export const LectureCardAwardTooltip: FC<ILectureAwardTooltip> = ({ award, iconWidth, iconHeight, iconColor }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!award) return;
  return (
    <Tooltip
      label={award}
      bg="white"
      hasArrow
      maxW={{ base: 'xs', lg: '4xl' }}
      placement="top"
      wordBreak="break-all"
      isOpen={isOpen}
    >
      <Flex
        color={iconColor ?? 'black'}
        tabIndex={0}
        role="button"
        aria-label="Show award"
        position="relative"
        zIndex={1}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onOpen();
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onOpen();
          }
        }}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        onFocus={onOpen}
        onBlur={onClose}
        justifyContent="center"
        alignItems="center"
      >
        <Box w={iconWidth} h={iconHeight} display="flex">
          <ICAward
            width={iconWidth !== undefined ? '100%' : undefined}
            height={iconHeight !== undefined ? '100%' : undefined}
          />
        </Box>
      </Flex>
    </Tooltip>
  );
};
